import * as React from 'react';
import Box from '@mui/material/Box';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import Typography from '@mui/material/Typography';

export default function BottomNav() {
  const location = useLocation();

  const navItems = [
    {
      id: 'home',
      label: 'Home',
      icon: <HomeIcon />,
      route: '/',
      activeColor: '#ff6b35'
    },
    {
      id: 'link-wallet',
      label: 'Link Wallet',
      icon: <AccountTreeIcon />,
      route: '/connect-wallet',
      activeColor: '#ffc107'
    },
    {
      id: 'history',
      label: 'History',
      icon: <ReceiptIcon />,
      route: '/transactions',
      activeColor: '#ffc107'
    },
    {
      id: 'assets',
      label: 'Assets',
      icon: <AccountBalanceWalletIcon />,
      route: '/assets',
      activeColor: '#ffc107'
    }
  ];

  const isActive = (route) => {
    if (route === '/') {
      return location.pathname === '/' || location.pathname === '/home';
    }
    return location.pathname.startsWith(route);
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#1a1a1a',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        paddingY: '8px',
        paddingX: '16px',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center'
      }}
    >
      {navItems.map((item) => {
        const active = isActive(item.route);
        return (
          <Box
            key={item.id}
            component={RouterLink}
            to={item.route}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              color: active ? item.activeColor : '#ffc107',
              flex: 1,
              paddingY: '4px',
              transition: 'color 0.2s'
            }}
          >
            <Box
              sx={{
                fontSize: '24px',
                marginBottom: '4px',
                color: active ? item.activeColor : '#ffc107'
              }}
            >
              {item.icon}
            </Box>
            <Typography
              sx={{
                fontSize: '10px',
                fontFamily: 'sans-serif',
                color: active ? item.activeColor : '#ffc107'
              }}
            >
              {item.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
